export default "__VITE_ASSET__BwRadZbK__"